import { render, staticRenderFns } from "./PlayerAdd.vue?vue&type=template&id=6e507389&scoped=true&"
import script from "./PlayerAdd.vue?vue&type=script&lang=js&"
export * from "./PlayerAdd.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAdd.vue?vue&type=style&index=0&id=6e507389&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e507389",
  null
  
)

export default component.exports